import { UserRepository, CompanyRepository } from "core/repository";
import { BasePresenter } from "core/presenter";
import { fn } from "util";

class DataTablePresenter extends BasePresenter {
  static sNoResultsFilter = [
    { field: "deleted", operation: "EQ", value: true },
    { field: "deleted", operation: "EQ", value: false }
  ];

  initialState() {
    return {
      loading: true,
      currentUser: {},
      resultSet: [],
      errorable: {
        visible: false,
        content: ""
      },
      order: {
        field: "name",
        direction: "ASC"
      },
      pagination: {
        perPage: 25,
        currentPage: 1,
        total: 0
      }
    };
  }

  async onStart() {
    this.filters = {
      name: "",
      email: "",
      company: ""
    };

    this.viewModel.currentUser = await this.mRuntime.get("currentUser");
    this.doLoadResults();
  }

  async doLoadResults() {
    this.viewModel.loading = true;
    this.renewCancelToken();

    const result = await UserRepository.getListOnline({
      order: [this.viewModel.order],
      pagination: {
        page: this.viewModel.pagination.currentPage,
        perPage: this.viewModel.pagination.perPage
      },
      filters: this.getFilter()
    });

    if (result.success) {
      this.viewModel.pagination = {
        ...this.viewModel.pagination,
        total: result.total,
        perPage: result.perPage
      };
      this.viewModel.resultSet = result.data;
    } else if (result.fatal) {
      await this.sendNotification({
        type: "error",
        title: "Oooops...",
        content:
          "Ocorreu um erro fatal ao se conectar com o servidor. Tente novamente mais tarde."
      });
    } else if (!result.userCancelled) {
      await this.sendNotification({
        type: "error",
        title: "Oooops...",
        content: "Não foi possível carregar os dados."
      });
    }

    this.viewModel.loading = false;
  }

  getFilter() {
    const repositoryFilters = [
      {
        connector: "AND",
        field: "company_uuid",
        operation: "EQ",
        value: this.viewModel.currentUser.company_uuid
      },
      { connector: "AND", field: "deleted", operation: "NOT", value: true }
    ];

    if (!fn.isBlank(this.filters.company.uuid)) {
      repositoryFilters.push({
        field: "company_uuid",
        operation: "EQ",
        value: this.filters.company.uuid
      });
    }

    if (!fn.isBlank(this.filters.name)) {
      repositoryFilters.push({
        field: "name",
        operation: "LIKE",
        value: this.filters.name
      });
    }

    if (!fn.isBlank(this.filters.email)) {
      repositoryFilters.push({
        field: "username",
        operation: "LIKE",
        value: this.filters.email
      });
    }

    return repositoryFilters;
  }

  async onOrderChange(field, direction) {
    this.viewModel.order = { field, direction };
    this.viewModel.pagination.currentPage = 1;
    this.doLoadResults();
  }

  onFilterChange(filters) {
    this.filters = filters;
    this.viewModel.pagination.currentPage = 1;
    this.doLoadResults();
  }

  onPageChange(page) {
    this.viewModel.pagination = {
      ...this.viewModel.pagination,
      currentPage: page
    };
    this.doLoadResults();
  }

  onViewUser(user) {
    this.navigateTo("app.registration.user.info", { userUuid: user.uuid });
  }

  onEditUser(user) {
    this.navigateTo("app.registration.user.form", { userUuid: user.uuid });
  }

  onRequestDelete(user) {
    const username = user.name || user.username || "Sem nome";
    this.sendNotification({
      type: "confirmation",
      title: "Você tem certeza?",
      content: `Tem certeza que deseja excluir o usuário ${username}?`,
      actions: [
        {
          label: "Voltar"
        },
        {
          label: "Sim, quero excluir",
          type: "accent",
          callback: () => this.doDelete(user.uuid)
        }
      ]
    });
  }

  async doDelete(uuid) {
    this.viewModel.loading = true;
    const result = await UserRepository.deleteUser(uuid);

    if (result.success) {
      await this.doLoadResults();
      await this.sendNotification({
        type: "success",
        content: "O usuário foi excluído."
      });
    } else if (result.fatal) {
      await this.sendNotification({
        type: "error",
        title: "Oooops...",
        content:
          "Ocorreu um erro fatal ao se conectar com o servidor. Tente novamente mais tarde."
      });
    } else {
      await this.sendNotification({
        type: "error",
        title: "Oooops...",
        content: "Não foi possível excluir o usuário."
      });
    }
    this.viewModel.loading = false;
  }

  async getUserCompany(companyUuid) {
    const result = await CompanyRepository.get(companyUuid);
    const companySlug = result.success ? result.data.slug : "";

    return companySlug;
  }
}

export default DataTablePresenter;



// WEBPACK FOOTER //
// ./src/components/app/registration/user/data-table/data-table.presenter.js